var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilteri = function SvgFilteri(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1357"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor',
    "data-name": "Group 5680"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2",
    "data-name": "Path 4325"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 11h-9.5a1 1 0 0 0 0 2h9.5a1 1 0 0 0 0-2",
    "data-name": "Path 4326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 16h-3.25a1 1 0 0 0 0 2h3.25a1 1 0 0 0 0-2",
    "data-name": "Path 4327"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilteri);
export default ForwardRef;